'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// import * as Helpers from '../common/helpers'


var _constants = require('../common/constants');

var Constants = _interopRequireWildcard(_constants);

var _chatEvents = require('../services/chatEvents');

var _chatEvents2 = _interopRequireDefault(_chatEvents);

var _dock = require('./dock');

var _chatreducer = require('./chatreducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageDispatcher = function () {
    function MessageDispatcher(context) {
        _classCallCheck(this, MessageDispatcher);

        this.invocationContext = context;

        this.setInvocationContext = this.setInvocationContext.bind(this);
        this.dispatch = this.dispatch.bind(this);
    }

    _createClass(MessageDispatcher, [{
        key: 'dispatch',
        value: function dispatch(packet) {
            // packet.payload = JSON.parse(packet.payload)
            var payload = JSON.parse(packet.payload);
            switch (payload.action) {
                case Constants.CHAT_ACTION_MESSAGE_NEW:
                    var chatMessage = {
                        meetingId: this.invocationContext.props.meetingId,
                        message: payload,
                        call_type: Constants.MESSAGE_CALL_TYPE_RECEIVE
                    };
                    this.invocationContext.props.dispatch((0, _chatreducer.addChatMessage)(chatMessage));
                    break;

                case Constants.CHAT_ACTION_USER_START_TYPING:
                    this.invocationContext.props.dispatch((0, _chatreducer.userStartTypingMessage)(payload));
                    break;

                case Constants.CHAT_EVENT_USER_JOIN:
                    var eventMessage = {
                        meetingId: this.invocationContext.props.meetingId,
                        message: payload,
                        call_type: Constants.MESSAGE_CALL_TYPE_RECEIVE
                    };
                    this.invocationContext.props.dispatch((0, _chatreducer.addChatMessage)(eventMessage));
                    break;

                case Constants.CHAT_EVENT_USER_LEAVE:
                    eventMessage = {
                        meetingId: this.invocationContext.props.meetingId,
                        message: payload,
                        call_type: Constants.MESSAGE_CALL_TYPE_RECEIVE
                    };
                    this.invocationContext.props.dispatch((0, _chatreducer.addChatMessage)(eventMessage));
                    break;

                case Constants.CHAT_NEW_PARTICIPANT:
                    chatMessage = {
                        meetingId: this.invocationContext.props.meetingId,
                        message: payload,
                        call_type: Constants.MESSAGE_CALL_TYPE_ADD_PARTICIPANT
                    };
                    this.invocationContext.props.dispatch((0, _chatreducer.addParticipant)(chatMessage));
                    break;

                case Constants.PAYLOAD_ACTION.MEETING_ENDED:
                    if (_chatEvents2.default.onMeetingEnded) {
                        _chatEvents2.default.onMeetingEnded(payload.data.meeting_id);
                    }
                    if (this.invocationContext.props.user_type === Constants.USER_TYPE.AGENT) {
                        (0, _dock.Dock)().removeDeck(payload.data.meeting_id);
                    } else {
                        // Client side meeting end handling
                        //payload.data.meeting_id
                        var _chatMessage = {
                            meetingId: this.invocationContext.props.meetingId,
                            message: payload,
                            call_type: Constants.MESSAGE_CALL_TYPE_RECEIVE
                        };
                        this.invocationContext.props.dispatch((0, _chatreducer.addChatMessage)(_chatMessage));
                        this.invocationContext.props.dispatch((0, _chatreducer.meetingEnded)(payload.data.meeting_id));
                    }
                    break;

                default:
                    console.warn('MessageDispatcher::dispatch() unhandled action ' + payload.action);
            }
        }
    }, {
        key: 'setInvocationContext',
        value: function setInvocationContext(context) {
            console.log('setInvocationContext');
            this.invocationContext = context;
        }
    }]);

    return MessageDispatcher;
}();

exports.default = MessageDispatcher;


// WEBPACK FOOTER //
// ../chat/lib/components/messagedispatcher.js